var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSadface(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 35,
    viewBox: "0 0 42 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_3397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7703 5.3231L15.8163 8.71406C15.7225 8.87804 15.7144 8.99609 15.8282 9.16094C15.9559 9.34548 16.2198 9.49271 16.4206 9.56339C16.6884 9.65763 16.9857 9.73096 17.2736 9.70747C17.4478 9.69052 17.7551 9.66516 17.8489 9.50117L19.7934 6.10513C19.8824 5.9386 19.8927 5.82785 19.779 5.66301C19.6513 5.47847 19.3921 5.33377 19.1913 5.2631C18.9235 5.16886 18.631 5.09808 18.3431 5.12156C18.1714 5.13375 17.8689 5.16166 17.7725 5.3304L17.7703 5.3231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8173 8.28501C22.1426 9.38652 21.5367 10.531 21.0073 11.704C20.938 11.8566 21.1374 12.0673 21.2293 12.147C21.418 12.3091 21.6997 12.423 21.9348 12.4754C22.3092 12.5532 22.9182 12.6158 23.1059 12.1961C23.3837 11.5737 23.6852 10.964 24.0084 10.3598L23.9371 10.493C24.2017 9.99816 24.4828 9.51828 24.776 9.03872C25.0135 8.65178 24.5152 8.33639 24.1926 8.21892C23.9369 8.12501 23.6491 8.05678 23.3707 8.08535C23.2038 8.10008 22.9159 8.12357 22.8148 8.28977L22.8173 8.28501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97716 16.9711C11.0459 17.3235 20.6157 19.7366 26.5245 27.1425C28.0553 29.0624 29.1057 31.1599 29.9871 33.4361C30.2305 34.068 32.32 34.4511 32.1035 33.6318C30.9508 29.277 27.667 25.4407 24.1512 22.7591C20.1435 19.7043 15.3576 17.8303 10.4463 16.8315C7.54893 16.2428 4.60526 15.9352 1.65629 15.8205C1.34527 15.8072 0.693038 15.8255 0.771865 16.2959C0.842168 16.7251 1.64457 16.9523 1.97971 16.9663L1.97716 16.9711Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_3397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.9876,
    height: 19.92,
    fill: "white",
    transform: "translate(9.39453) rotate(28.1356)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadface);
export default __webpack_public_path__ + "static/media/sadface.3050456e2729261669f3636fb97709f0.svg";
export { ForwardRef as ReactComponent };